export default function () {
    const schema = {};
    const $config = useRuntimeConfig().public;
    const $route = useRoute();

    schema.organization = {
        '@type': 'Organization',
        name: $config.siteName,
        logo: {
            '@type': 'ImageObject',
            url: $config.base + $config.images + $config.siteEmailLogo,
        },
    };

    schema.build = function (data) {
        let textContent = {
            '@context': 'https://schema.org/',
            '@graph': [
                schema.organization,
            ]
        };

        if (data instanceof Array) {
            textContent["@graph"].push(...data);
        } else if (data instanceof Object) {
            data.url = $config.base + $route.path;
            textContent["@graph"].push(data);
        }

        return {
            hid: 'jsonld',
            type: 'application/ld+json',
            innerHTML: JSON.stringify(textContent),
        };
    };

    return schema;
};
